import React from "react"
import Home from "./pages/Home";
import "./App.css";

function App() {
  return (
    <div className="mx-auto overflow-hidden">
      <Home />
    </div>
  );
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js